import {DomainStore} from 'shared/store';
import { makeAutoObservable } from 'mobx';
import {endpoints, types} from 'main/tools';

class MassUpdatesDirectoryState {
  store = new DomainStore();
  history;

  massUpdateType = 'job';

  constructor() {
    makeAutoObservable(this, {
      store: false,
      history: false
    });
  }

  receiveProps({history}) {
    this.history = history;
  }

  goToMassUpdateEdit(massUpdate) {
    this.history.push(`/${massUpdate.id}`);
  }

  async removeMassUpdate(model) {
    await this.store.destroy(model);
  }

  updateMassUpdateType(value) {
    this.massUpdateType = value;
  }

  async createMassUpdate() {
    const {model} = await this.store.post(
      `${endpoints.MASS_UPDATES.ALL}?type=${this.massUpdateType}`,
      types.MASS_UPDATE_SUMMARY
    );

    if (model) {
      this.goToMassUpdateEdit(model);
    }
  }
}

export default MassUpdatesDirectoryState;
